 import axios from "axios";
  import store from "../../store/index";
  import customModal from "../customModal/customModal.vue";

  export default{
      name: 'AssignEproPopup',
      components: {
          customModal
      },
      props: {
          subjectId: {
              type: String,
              default: ''
          },
          visitName :{
              type: String,
              default: ''
          }    
      },
      data(){
          return{
              baseapi: process.env.VUE_APP_Service_URL,
              selectedPatientId : "",
              showAssignForm: false,
              ecrfformlist: [], 
              referanceType:"",
              occuranceStartDate: "",
              totalOccurance :0,
              templateName :"",
              templateId: "",

          }
      },
      async mounted(){
          console.log("AssignEproPopup mounted");
          await this.getEPROFormsList();
          
      },
      methods:{
        async getEPROFormsList() {
              const idtoken = store.getters.getIdToken;
              const currentstudy = await store.getters.getStudyIs;
              await axios
                  .get(`${this.baseapi}/management/epro/ecrfformslist?studyId=${currentstudy}&category=ePRO`, {
                      headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                      },
                  })
                  .then((response) => {
                  if (response.data) {
                      this.ecrfformlist = response.data.entities;
                  } else {
                      console.log("No ePRO forms found");
                  }
                  })
                  .catch((err) => {
                  console.log(err);
                  });
        },
        async saveForm(forms) {
          const idtoken = store.getters.getIdToken;
          try {
              if ((forms.useDate && forms.useRecurrence) || (!forms.useDate && !forms.useRecurrence)) {
                  alert("Please choose either 'Select Date' or 'Recurrence Cycle'.");
                  return;
              }
              if (forms.useDate) {
                  if (!forms.selectedDate) {
                      alert("Please select a date.");
                      return;
                  }
              }
              if (forms.useRecurrence) {
                  if (!forms.selectedRecurrence) {
                      alert("Please select a recurrence cycle.");
                      return;
                  }
                  if (!forms.recurrenceFromDate) {
                      alert("Please select a start date.");
                      return;
                  }
                  if (!forms.occurrence || forms.occurrence < 1 ||  !Number.isInteger(forms.occurrence)) {
                      alert("Please enter a valid whole number (min 1).");
                      return;
                  }
              }
              this.referanceType = "";
              this.occuranceStartDate = "";
              this.totalOccurance = "";
              if (forms.useDate) {
                  this.occuranceStartDate = forms.selectedDate;
                  this.totalOccurance = 1;
                  this.referanceType = "Daily";
              } else if (forms.useRecurrence) {
                  this.referanceType = forms.selectedRecurrence;
                  this.occuranceStartDate = forms.recurrenceFromDate;
                  this.totalOccurance = forms.occurrence;
              }

              this.templateName = forms.templateName;
              this.templateId = forms.template_ID;

              const response = await axios.post(
                  `${this.baseapi}/management/patientschedule/eprooccurrenceforms?SubjectId=${this.subjectId}&ReferanceType=${this.referanceType}&OccuranceStartDate=${this.occuranceStartDate}&VisitName=${this.visitName}&TotalOccurance=${this.totalOccurance}&TemplateName=${this.templateName}&TemplateId=${this.templateId}&visitType=Subject%20Visit`,
                  {},
                  {
                      headers: {
                          Authorization: "Bearer " + idtoken,
                          "Content-Type": "application/json",
                      },
                  }
              );
              alert(this.$t("navigations.epro forms assigned successfully"));
              this.referanceType = "";
              this.occuranceStartDate = "";
              this.totalOccurance = "";
              this.templateName = "";
              this.templateId = "";
              if (forms.useDate) {
                  forms.selectedDate = "";
                  forms.useDate = false;
              }
              if (forms.useRecurrence) {
                  forms.selectedRecurrence = "";
                  forms.recurrenceFromDate = "";
                  forms.occurrence = "";
                  forms.useRecurrence = false;
              }
              console.log("API Response:", response.data);
          } catch (error) {
              console.error("Error calling ePRO occurrence forms API:", error);
          }
        },
        closeAssignModal() {
          this.$emit("closemodal");  
          this.ecrfformlist = [];
        }
      }

  };